/**
 * Initial state factory for the "restrict" Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation. `isRestricted` flags whether
 * restriction is currently in effect.
 */
export default () => ({
    isRestricted: false,
});
